import { Box, Chip, Typography } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TopErrorLink } from '../../types/apiRequests'
import { border } from '../../layout/theme/border'
import { fadeSlideIn } from './animations'

export const TopErrorsList: FC<{
  title: string
  items: TopErrorLink[]
  linkPrefix: string
  hrefBuilder?: (item: TopErrorLink) => string | null
  accent: string
  delay: number
}> = ({ title, items, linkPrefix, hrefBuilder, accent, delay }) => {
  const navigate = useNavigate()
  const buildHref = (item: TopErrorLink) =>
    hrefBuilder?.(item) ?? `/${linkPrefix}/${item.link_id}`

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: border.card.radius,
        border: '1px solid rgba(0,0,0,0.06)',
        animation: `${fadeSlideIn} 0.5s ease-out ${delay}ms both`,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ px: 2.5, py: 2, borderBottom: '1px solid rgba(0,0,0,0.04)' }}>
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 600,
            color: 'rgba(0,0,0,0.3)',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
          }}
        >
          {title}
        </Typography>
      </Box>
      {items.length === 0 ? (
        <Box sx={{ px: 2.5, py: 3, textAlign: 'center' }}>
          <Typography sx={{ fontSize: 13, color: 'rgba(0,0,0,0.25)' }}>
            Geen fouten deze week
          </Typography>
        </Box>
      ) : (
        items.map((item, i) => (
          <Box
            key={item.link_id}
            onClick={() => navigate(buildHref(item))}
            sx={{
              'px': 2.5,
              'py': 1.5,
              'display': 'flex',
              'alignItems': 'center',
              'justifyContent': 'space-between',
              'gap': 2,
              'cursor': 'pointer',
              'borderBottom':
                i < items.length - 1 ? '1px solid rgba(0,0,0,0.03)' : 'none',
              'transition': 'background 0.15s',
              '&:hover': { background: 'rgba(0,0,0,0.015)' },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#1a1a1a',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.name}
              </Typography>
              <Typography sx={{ fontSize: 11, color: 'rgba(0,0,0,0.35)' }}>
                {item.organization_name}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
              <Chip
                label={`${item.error_count} / ${item.total_count}`}
                size="small"
                sx={{
                  fontWeight: 600, fontSize: 11, height: 22, border: 'none',
                  bgcolor: `${accent}12`, color: accent,
                }}
              />
            </Box>
          </Box>
        ))
      )}
    </Box>
  )
}
